<template>
    <main>
        <div class="modal fade" id="modalRemisiones" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Listado de Remisiones, Historia No: {{id_historia}}</h5>
                    <button type="button" class="close"  @click="cerrar();" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="card mt-2 shadow-none"  v-if="isLoading">
                        <div class="card-body">
                          <content-placeholders :rounded="true">
                            <content-placeholders-heading :img="false" />
                            <content-placeholders-text :lines="3" />
                          </content-placeholders>
                        </div>
                    </div>
                    <div class="alert alert-warning mt-2" v-else-if="!remisiones.length">
                        No existen remisiones...
                    </div>
                    <div v-else class="card mt-2 border-gray-500 shadow-none" v-for="item in remisiones" :key="item.id">
                        <div class="card-header bg-light">
                            <div class="row">
                                <div class="col-4 ">
                                    Remisión No. {{item.id}} 
                                </div>
                                <div class="col-8 d-flex justify-content-end">
                                    <span class="text-danger mx-2">{{item.user.name}}</span> ({{item.created_at | formatDateTime}})
                                    <button @click="imprimir(item.id);" class="btn btn-outline-info lift mx-2 shadow-sm btn-sm" >
                                        <i class="fa fa-print fa-fw"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body" >
                            <div class="row">
                                <div class="col-md-4 col-sm-12 col-lg-4">
                                    Servicio <span class="text-danger">({{item.servicio.codigo}}) :</span>
                                </div>
                                <div class="col-md-8 col-sm-12 col-lg-8">
                                    <span class="text-primary">{{item.servicio.descripcion}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4 col-sm-12 col-lg-4">
                                    Institución: 
                                </div>
                                <div class="col-md-8 col-sm-12 col-lg-8">
                                    <span class="text-bold">{{item.institucion}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4 col-sm-12 col-lg-4">
                                    Motivo:
                                </div>
                                <div class="col-md-8 col-sm-12 col-lg-8">
                                    <p class="text-black-50">{{item.motivo}}</p>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light btn-sm" @click="cerrar();"><i class="far fa-times-circle fa-fw"></i> Cerrar</button>
                </div>
                </div>
            </div>
        </div>
        
    </main>
</template>
<script>

import remisionService from '../../../../services/remisionService';
import $ from "jquery";
export default {
    data(){
        return {
            id_historia:'',
            remisiones:{},
            isLoading:true
        }
    },
    methods: {
        async  abrir(id){
            this.$nextTick(async () => {
                this.id_historia =id;
                $("#modalRemisiones").modal("show");
                this.isLoading = true;
                const response = await remisionService.showRemisionByHc(id);
                this.remisiones= response.data;
                this.isLoading = false;
            });
        },
        imprimir(id_remision){
            window.open(remisionService.print(this.id_historia,id_remision));
        },
        cerrar(){
            $("#modalRemisiones").modal("hide");
            this.remisiones= {};
        }
    },
}
</script>